import React, { useState, useRef, useEffect } from "react";
import "../Home/Home.css";

const ITEMS_PER_VIEW = 3;

const TestimonialReviewPreview = ({
    previewService = [],
    setShowPreviewTestimonialReview
}) => {

  
    const [startIndex, setStartIndex] = useState(0);
    const [expandedReviews, setExpandedReviews] = useState({});
    const [overflowMap, setOverflowMap] = useState({});
    const reviewRefs = useRef({});

    const safeReviews = Array.isArray(previewService) ? previewService : [];

    const visibleReviews = safeReviews.slice(
        startIndex,
        startIndex + ITEMS_PER_VIEW
    );

    useEffect(() => {
        const newOverflowMap = {};

        visibleReviews.forEach((r) => {
            const el = reviewRefs.current[r.review_id];
            if (el) {
                newOverflowMap[r.review_id] =
                    el.scrollHeight > el.clientHeight;
            }
        });

        setOverflowMap(newOverflowMap);
    }, [visibleReviews]);

    const handleNext = () => {
        if (startIndex + ITEMS_PER_VIEW < safeReviews.length) {
            setStartIndex(startIndex + ITEMS_PER_VIEW);
        }
    };

    const handlePrev = () => {
        if (startIndex - ITEMS_PER_VIEW >= 0) {
            setStartIndex(startIndex - ITEMS_PER_VIEW);
        }
    };

    const toggleReview = (id) => {
        setExpandedReviews((prev) => ({
            ...prev,
            [id]: !prev[id],
        }));
    };

    if (safeReviews.length === 0) return null;

    return (
        <div
            className="tp-overlay"
            onClick={() => setShowPreviewTestimonialReview(false)}
        >
            <div
                className="tp-modal"
                onClick={(e) => e.stopPropagation()}
            >

                <button
                    className="tp-close"
                    onClick={() => setShowPreviewTestimonialReview(false)}
                >
                    ✕
                </button>

                <div className="tp-carousel">

                    <button
                        className="tp-arrow left"
                        onClick={handlePrev}
                        disabled={startIndex === 0}
                    >
                        ‹
                    </button>

                    <div className="tp-reviews">
                        {visibleReviews.map((r) => (
                            <div className="tp-review-card" key={r.review_id}>

                                <div className="tp-review-header">
                                    <img
                                        src={r.imageupload || "/default-user.png"}
                                        alt={r.name}
                                    />

                                    <div>
                                        <h4>{r.name}</h4>
                                        <span>{r.professional}</span>
                                    </div>

                                    <div className="tp-rating">
                                        {"★".repeat(r.rating)}
                                        {"☆".repeat(5 - r.rating)}
                                    </div>
                                </div>

                                <hr className="expressdividers col-12 mt-4" />

                                <p
                                    ref={(el) => (reviewRefs.current[r.review_id] = el)}
                                    className={`tp-review-text ${expandedReviews[r.review_id] ? "" : "clamp"}`}
                                    dangerouslySetInnerHTML={{ __html: r.description }}
                                />

                                {(overflowMap[r.review_id] || expandedReviews[r.review_id]) && (
                                    <button
                                        className="tp-readmore"
                                        onClick={() => toggleReview(r.review_id)}
                                    >
                                        {expandedReviews[r.review_id] ? "Hide" : "Read more"}
                                    </button>
                                )}
                            </div>
                        ))}
                    </div>

                    <button
                        className="tp-arrow right"
                        onClick={handleNext}
                        disabled={startIndex + ITEMS_PER_VIEW >= safeReviews.length}
                    >
                        ›
                    </button>

                </div>
            </div>
        </div>
    );
};

export default TestimonialReviewPreview;
